module.exports = __webpack_public_path__ + "img/seirikinoukensa.788c618e.png";